import axios from "axios"
import Tools from '@/tools/tools'
import token from '../tools/tokenTools'
import config from '@/configs/appConfig'
import {ElMessage} from "element-plus";

/**
 * request配置
 */
let axiosConfig = {
    baseURL: config.http
};

/**
 * request请求
 */
const http = axios.create(axiosConfig)

/**
 * 请求拦截器
 */
http.interceptors.request.use((config) => {
    const accessToken = token.get()
    if (accessToken) {
        config.headers.Authorization = Tools.ucFirst(accessToken.token_type) + accessToken.access_token
    }
    return config
}, function (error) {
    return error
})

/**
 * 响应拦截器
 */
http.interceptors.response.use((response) => {
    token.updateExpiresIn()
    return response
}, function (error) {
    // console.log('freddy x', error)
    if (error?.response?.status == 422) {
        ElMessage({
            message: '请求参数有误，请检查：' + JSON.stringify(error?.response?.data?.error),
            type: 'warning',
        })
    }
    if (error?.response?.status == 500) {
        ElMessage({
            message: '服务端异常：' + JSON.stringify(error?.response?.data?.error),
            type: 'error',
        })
    }
    if (error?.response?.status == 400) {
        ElMessage({
            message: error?.response?.data?.error?.message || '400状态码',
            type: 'warning',
        })
    }
    return Promise.reject(error)
})

const request = {
    get: function (url, params, header = {}) {
        return http.get(url, {
            params: params
        }, header)
    },
    getAsync: async function (url, params, header = {}) {
        return await http.get(url, {
            params: params
        }, header).then((r) => {
            return r.data
        }).catch((r) => {
            return r.response.data
        })
    },
    post: function (url, params, header = {}) {
        return http.post(url, params, header)
    },
    postAsync: async function (url, params, header = {}) {
        return await http.post(url, params, header).then((r) => {
            return r.data
        }).catch((r) => {
            return r.response.data
        })
    },
    put: function (url, params, header = {}) {
        return http.put(url, params, header)
    },
    del: function (url, params, header = {}) {
        return http.delete(url, params, header)
    },
    download: function (url, params, filename, callbackFn = undefined) {
        http.get(url, {
            params: params,
            responseType: "blob"
        }).then(r => {
            if (callbackFn) {
                callbackFn()
            }
            const url = window.URL.createObjectURL(new Blob([r.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }))
            const a = document.createElement('a')
            a.style.display = "none"
            a.href = url
            a.setAttribute('download', filename)
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }).catch(error => {
        // 捕获错误并处理
        if (error?.response?.status === 500) {
            ElMessage({
                message: '服务端异常：' + JSON.stringify(error?.response?.data?.error),
                type: 'error',
            });
        } else if (error?.response?.status === 422) {
            ElMessage({
                message: '请求参数有误，请检查：' + JSON.stringify(error?.response?.data?.error),
                type: 'warning',
            });
        } else if (error?.response?.status === 400) {
            ElMessage({
                message: error?.response?.data?.error?.message || '400状态码',
                type: 'warning',
            });
        } else if (error?.code === 'ERR_NETWORK') {
            ElMessage({
                message: '请求异常，导出的资源过大或网络异常导致，请重试！',
                type: 'error',
            });
        } else {
            ElMessage({
                message: '未知错误：' + error.message,
                type: 'error',
            });
        }
        console.error('Download Error:', error);
    });
    }
}

export default request
